import { getItemOrDefaultToValue, nestedDisplay } from '../../details';
import { riskColors } from 'utils/constants/risks';
import {
  getRiskConsequence,
  getRiskConsequenceId,
  getRiskLevelId,
  getRiskLevelValue,
  getRiskLikelihood,
  getRiskLikelihoodId,
} from '../../helper/zone';

export const zoneDetailsTransform = (data, globalDepartmentList = []) => {
  const selectedDepartments = globalDepartmentList.filter(f =>
    getItemOrDefaultToValue(data, 'departmentIds', []).includes(f.id),
  );

  return {
    generalInfo: {
      name: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'name', '-'),
      },
      archived: {
        type: 'boolean',
        value: getItemOrDefaultToValue(data, 'archived', false),
      },
      riskLevel: {
        type: 'text',
        value: getRiskLevelValue(data.currentRisk),
        idValue: getRiskLevelId(data?.currentRisk?.rating),
      },
      hazard: {
        type: 'text',
        value: getItemOrDefaultToValue(data.currentRisk, 'context', '-'),
      },
      consequence: {
        type: 'text',
        value: getRiskConsequence(data.currentRisk),
        idValue: getRiskConsequenceId(data?.currentRisk?.consequence),
      },
      likelihood: {
        type: 'text',
        value: getRiskLikelihood(data.currentRisk),
        idValue: getRiskLikelihoodId(data?.currentRisk?.likelihood),
      },
      departments: {
        type: 'array',
        value: nestedDisplay(selectedDepartments),
      },
    },
    detailedInfo: {
      descriptionIncludingRiskContext: {
        type: 'text',
        value: getItemOrDefaultToValue(data.currentRisk, 'description', '-'),
      },
      recommendation: {
        type: 'text',
        value: getItemOrDefaultToValue(
          data.currentRisk,
          'defaultRecommendation',
          '-',
        ),
      },
      boundary: {
        type: 'map-array',
        value: {
          center: {
            lat: data.boundary?.centreOfGravity.latitude,
            lng: data.boundary?.centreOfGravity.longitude,
          },
          riskLevel: getRiskLevelId(data.currentRisk?.rating),
          boundary: getItemOrDefaultToValue(data.boundary, 'points', []).map(
            boundary => {
              return {
                lat: boundary.latitude,
                lng: boundary.longitude,
              };
            },
          ),
          tableView: false,
        },
      },
    },
    others: {
      id: { value: getItemOrDefaultToValue(data, 'id') },
      locations: {
        value:
          data.boundary != null
            ? [
                {
                  editable: true,
                  draggable: false,
                  color:
                    riskColors[
                      getRiskConsequenceId(data.currentRisk.consequence)
                    ],
                  isFilled: true,
                  paths: getItemOrDefaultToValue(data.boundary, 'points').map(
                    point => ({
                      lat: point.latitude,
                      lng: point.longitude,
                    }),
                  ),
                },
              ]
            : [],
      },
      centreOfGravity: getItemOrDefaultToValue(
        data.boundary,
        'centreOfGravity',
        null,
      ),
    },
  };
};
